import config from 'config';
import { http_client } from './api';

const getList = async (status, page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'parent/list/' +
        status +
        '?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'parent', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'parent/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'parent/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'parent/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'parent/status/' + id, data).then((response) => {
    return response.data;
  });
};

const updatePhoto = async (id, data) => {
  return http_client.post(config.apiUrl + 'parent/photo/' + id, data).then((response) => {
    return response.data;
  });
};

const deletePhoto = async (id) => {
  return http_client.delete(config.apiUrl + 'parent/photo/' + id).then((response) => {
    return response.data;
  });
};

const addBank = async (id, data) => {
  return http_client.post(config.apiUrl + 'parent/' + id + '/bank', data).then((response) => {
    return response.data;
  });
};

const updateBank = async (id, bankID, data) => {
  return http_client.post(config.apiUrl + 'parent/' + id + '/bank/' + bankID, data).then((response) => {
    return response.data;
  });
};

const deleteBank = async (id, bankID) => {
  return http_client.delete(config.apiUrl + 'parent/' + id + '/bank/' + bankID).then((response) => {
    return response.data;
  });
};

const ParentService = {
  getList,
  create,
  read,
  update,
  del,
  changeStatus,
  updatePhoto,
  deletePhoto,
  addBank,
  updateBank,
  deleteBank
};

export default ParentService;
